import React from 'react';
import translations from 'decorators/translations.js';
import configuredRadium from 'configuredRadium.js';
import { colors, fonts, size, layout } from 'styles/design.js';

const bannerStyle = [
    fonts.arial,
    size.normal,
    layout.textCenter,
    {
        position: 'sticky',
        top: '4em', // nav height, see Navigation.js
        zIndex: 100000, // below the nav's 100001
        width: '100%',
        padding: '0.75em 1em',
        // basicRed + white + warning icon matches the Notificator error bar convention
        backgroundColor: colors.basicRed,
        color: colors.white
    }
];

const iconStyle = { width: '1.5em', verticalAlign: 'middle', marginRight: '0.5em' };

const ReadOnlyBanner = (props) => (
    <div id="readOnlyBanner" style={ bannerStyle }>
        <img style={ iconStyle } alt="warning" src={ require('images/icons/Icon_Warning.svg') } />
        { props.t('read_only_banner_text') }
    </div>
);

export default translations(configuredRadium(ReadOnlyBanner));
